import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// layout下的子路由
const pro_children = [
  {
    path: 'pre',
    component: () => import('@/views/pre.vue')
  },
  {
    path: 'start',
    component: () => import('@/views/start.vue')
  },
  {
    path: 'online',
    component: () => import('@/views/online.vue')
  },
  {
    path: 'acceptance',
    component: () => import('@/views/acceptance.vue')
  },
  {
    path: 'research',
    component: () => import('@/views/research.vue')
  },
  {
    path: 'progress',
    component: () => import('@/views/progress.vue')
  }
]
const main_children = [
  {
    path: 'projectCanten',
    component: () => import('@/views/projectCanten.vue')
  },
  {
    path: 'project',
    component: () => import('@/views/project.vue'),
    children: pro_children
  },
  {
    path: 'tydy',
    component: () => import('@/views/tydy.vue')
  },
  {
    path: 'erkai',
    component: () => import('@/views/erkai.vue')
  },
  {
    path: 'bhd',
    component: () => import('@/views/bhd.vue')
  },
  {
    path: 'dictionary',
    component: () => import('@/views/dictionary.vue')
  }
]

const routes = [
  {
    path: '/',
    redirect: '/Login'
  },
  // 登录页
  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  // 主页
  {
    path: '/main',
    name: 'main',
    component: () => import('@/views/main.vue'),
    children: main_children
  },
  // 主页
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
